'use strict';

var JsBarcode = require('jsbarcode'),
    dialog = require('./dialog');

/**
 * @function init
 * @description Initializes the barcodes
 */
exports.init = function () {
    var barcodes = $('.barcode-js');
    var barcodeElId;
    if (barcodes.length > 0) {
        barcodes.each(function (key, barcode) {
            if (barcode.id !== undefined) {
                barcodeElId = '#' + barcode.id;
                JsBarcode(barcodeElId).init();
            }
        });
        initViewBarcodeModal();
    }
};
function initViewBarcodeModal()
{
    $('.barcode-container .view-barcode').on('click', function (e) {
        e.preventDefault();
        var id = $(this).data('id');
        if(id !== undefined) {
            viewBarcodeModel(id);
        }
   })
}
function viewBarcodeModel(id)
{
    var htmlEl = $('#history-code-'+id).clone();
    if (!htmlEl || htmlEl.length <=0) {
        return;
    }
    dialog.open({
        html: htmlEl[0],
        options: {
            width: 400,
            modalClass: 'modal--barcode align--center',
            buttons: [{
                click: function () {
                    $(this).dialog('close');
                }
            }]
        }
    });
}

exports.initBarcodeByElements = function(el) {
    if(!el || $(el).length <= 0) {
        return;
    }
    var barcodeElId;
    $(el).each(function (key, barcode) {
        if (barcode.id !== undefined) {
            barcodeElId = '#' + barcode.id;
            JsBarcode(barcodeElId).init();
        }
    });
    initViewBarcodeModal();
};


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/barcode.js